var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIandw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.893C15 10.3056 14.8361 10.7012 14.5444 10.9929C14.2527 11.2847 13.857 11.4486 13.4444 11.4486H4.11111L1 14.5597V2.11522C1 1.70266 1.16389 1.307 1.45561 1.01527C1.74733 0.72355 2.143 0.559662 2.55556 0.559662H13.4444C13.857 0.559662 14.2527 0.72355 14.5444 1.01527C14.8361 1.307 15 1.70266 15 2.11522V9.893Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIandw);
export default __webpack_public_path__ + "static/media/iandw.743eb9c7bd9d40f5a050f6f9070bb75a.svg";
export { ForwardRef as ReactComponent };